import type { IconData } from '@stacksjs/iconify-core'

export const shoppingGift: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M5 0H4v3H1v3h14V3h-3V0h-1a3 3 0 0 0-3 3a3 3 0 0 0-3-3m10 7.5H8.75V16H15zM7.25 16V7.5H1V16z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default shoppingGift
